
import { mapGetters } from 'vuex';
import UINewsPost from '@/components/ui/organism/UINewsPost';
import UIProfilePost from '@/components/ui/organism/UIProfilePost';
import UIDeletedPost from '@/components/ui/organism/UIDeletedPost';
import { getMedia, isMobileResponsive } from '@/utils/mixins';
import { generatePostUrl } from '@/utils/url-generator';
import UIPortfolioCard from '@/components/ui/molecule/PortfolioCard/UIPortfolioCard';
import { redirectToPost } from '~/utils/route-redirects';
import { PostInteractionType } from '~/utils/behavior/applicationEvents/gtm-data-types';
import { eventManager } from '@/utils/behavior/applicationEvents/event-manager';

export default {
  name: 'UIPost',
  components: {
    UIProfilePost,
    UINewsPost,
    UIDeletedPost,
    UIPortfolioCard,
  },

  mixins: [getMedia, isMobileResponsive],
  props: {
    post: {
      type: Object,
      default: () => null,
    },
    disableHover: {
      type: Boolean,
      default: false,
    },
    isSocialInteractionDisabled: {
      type: Boolean,
      default: false,
    },
    showOptions: {
      type: Boolean,
      default: true,
    },
    isPostPage: {
      type: Boolean,
      default: false,
    },
    showReplies: {
      type: Boolean,
      default: false,
    },
    showCard: {
      type: Boolean,
      default: true,
    },
    portfolio: {
      type: Object,
      default: () => null,
    },
    isMobileReply: {
      type: Boolean,
      default: false,
    },
    isRepost: {
      type: Boolean,
      default: false,
    },
    disableTruncate: {
      type: Boolean,
      default: false,
    },
    alignmentDirection: {
      type: String,
      default: 'center',
    },
    socialInteractionsGap: {
      type: String,
      default: '4',
    },
    league: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      mentionIds: [],
      mentionedPost: null,
      openMoreMenu: false,
      icoRegex: /([a-zA-Z0-9\s_\\.\-():])+(.ico)$/i,
    };
  },
  computed: {
    ...mapGetters('authentication', ['profile']),
    routeName() {
      return this.$route.name?.split('_')[0];
    },
    postTitle() {
      return this.post.entityType === 'NEWS'
        ? this.post.newsArticleDetail.title
        : '';
    },
  },
  methods: {
    goToPost() {
      this.$emit('goToPost');
    },
    onUserClick() {
      this.$emit('onUserClick');
    },
    mouseEnterMention(payload) {
      this.$emit('mouseEnterMention', {
        pos: payload.pos,
        profile: payload.profile,
        id: payload.id,
      });
    },
    mouseOutMention(payload) {
      this.$emit('mouseOutMention', {
        pos: payload.pos,
        id: payload.id,
      });
    },
    likePost() {
      this.$emit('onLike');
      this.raiseGtmInteractionEvent(
        this.post.isLiked
          ? PostInteractionType.Unlike
          : PostInteractionType.Like
      );
    },
    onReply() {
      this.raiseGtmInteractionEvent(PostInteractionType.Comment);
      if (this.isMobileResponsive) {
        redirectToPost(this.post.postId);
      } else {
        this.$emit('onReply');
      }
    },
    onReplyMobile() {
      this.raiseGtmInteractionEvent(PostInteractionType.Comment);
      this.$emit('onReplyMobile');
    },
    onRepost() {
      this.raiseGtmInteractionEvent(PostInteractionType.Repost);
      this.$emit('onRepost');
    },
    onShare() {
      this.raiseGtmInteractionEvent(PostInteractionType.Share);
      {
        if (navigator.share) {
          navigator.share({
            url: generatePostUrl(this.post.postId),
          });
        }
      }
    },
    onFavorite() {
      this.raiseGtmInteractionEvent(
        this.post.isFavorited
          ? PostInteractionType.Unsave
          : PostInteractionType.Save
      );
      this.$emit('handleFavorite');
    },
    raiseGtmInteractionEvent(eventAction) {
      eventManager.raiseInteractionArticleEvent({
        post_id: this.post.postId,
        post_name: this.postTitle,
        event_category: 'Post Interaction',
        event_action: eventAction,
        post_author: this.post.author.profileName,
        post_author_id: this.post.author.profileId,
        post_interactor: this.profile.profileName,
        post_interactor_id: this.profile.profileId,
      });
    },
  },
};
